import React, { useRef } from "react";
import useClickedOutside from "@src/hooks/useClickedOutside";

interface ClickedOutsideContainerProps {
  children?: React.ReactNode;
  onClickedOutside: () => void;
}

export default function ClickedOutsideContainer({
  children,
  onClickedOutside,
}: ClickedOutsideContainerProps): React.ReactNode | null {
  const containerRef = useRef<HTMLDivElement>(
    null,
  ) as React.RefObject<HTMLElement>;
  useClickedOutside(containerRef, onClickedOutside);

  return <div ref={containerRef}>{children}</div>;
}
